// extracted by mini-css-extract-plugin
module.exports = {"riverInfo":"river_info_riverInfo__2TuDw"};